import type { FaireProductEntity } from "../../entity_types/product";

export const p_y97pws7njz: FaireProductEntity = {
  token: "p_y97pws7njz",
  type: "product",
  name: "Happy Little Demitasse Spoon",
  brandToken: "b_sbb9hxmx99",
  brandName: "Touchy Coffee",
  imageUrl: "https://cdn.faire.com/fastly/76142bb32f2167a6d3769577431b45c4106bb8727b12e484afc31eff1f2748e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1e10aac770313703dd15082e47a3af11ceb8904552194b9220a3d6df4657e36.png",
    "https://cdn.faire.com/fastly/3245562476eb688c26f95500929b64c063dd891e0021f32b7cc4bf4b5cd789a8.png",
    "https://cdn.faire.com/fastly/1cfc992952258be987beaaa5b8468cbcdaba567871c63e3fb8e756ddd4fa2201.png"
  ],
  priceDollars: 4,
  description: "Material Stainless Steel \nMade By Tsubamesanjo in Japan \nSize 9.7cm x 2.2cm \nA sweet n silly little spoon to stir your espresso (or anything else) with! By stirring your espresso before sipping you guarantee you're getting smooth and balanced sips from top to bottom.\n\n\nDishwasher safe. Made in Japan.\n",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:18.235Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
